/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnteUpdateDTO
 */
export interface EnteUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof EnteUpdateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteUpdateDTO
     */
    regioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteUpdateDTO
     */
    provinciaId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteUpdateDTO
     */
    comuneId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteUpdateDTO
     */
    nazioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteUpdateDTO
     */
    regione?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteUpdateDTO
     */
    provincia?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteUpdateDTO
     */
    comune?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteUpdateDTO
     */
    localita?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteUpdateDTO
     */
    indirizzo?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteUpdateDTO
     */
    numeroCivico?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteUpdateDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteUpdateDTO
     */
    telefono?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteUpdateDTO
     */
    cellulare?: string;
    /**
     * 
     * @type {string}
     * @memberof EnteUpdateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the EnteUpdateDTO interface.
 */
export function instanceOfEnteUpdateDTO(value: object): value is EnteUpdateDTO {
    return true;
}

export function EnteUpdateDTOFromJSON(json: any): EnteUpdateDTO {
    return EnteUpdateDTOFromJSONTyped(json, false);
}

export function EnteUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnteUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'regioneId': json['regioneId'] == null ? undefined : json['regioneId'],
        'provinciaId': json['provinciaId'] == null ? undefined : json['provinciaId'],
        'comuneId': json['comuneId'] == null ? undefined : json['comuneId'],
        'nazioneId': json['nazioneId'] == null ? undefined : json['nazioneId'],
        'regione': json['regione'] == null ? undefined : json['regione'],
        'provincia': json['provincia'] == null ? undefined : json['provincia'],
        'comune': json['comune'] == null ? undefined : json['comune'],
        'localita': json['localita'] == null ? undefined : json['localita'],
        'indirizzo': json['indirizzo'] == null ? undefined : json['indirizzo'],
        'numeroCivico': json['numeroCivico'] == null ? undefined : json['numeroCivico'],
        'email': json['email'] == null ? undefined : json['email'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'cellulare': json['cellulare'] == null ? undefined : json['cellulare'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function EnteUpdateDTOToJSON(value?: EnteUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'regioneId': value['regioneId'],
        'provinciaId': value['provinciaId'],
        'comuneId': value['comuneId'],
        'nazioneId': value['nazioneId'],
        'regione': value['regione'],
        'provincia': value['provincia'],
        'comune': value['comune'],
        'localita': value['localita'],
        'indirizzo': value['indirizzo'],
        'numeroCivico': value['numeroCivico'],
        'email': value['email'],
        'telefono': value['telefono'],
        'cellulare': value['cellulare'],
        'note': value['note'],
    };
}

